module.exports = __webpack_public_path__ + "img/zhili-1.fb2d9925.jpg";